<div [ngClass]="[backgroundImage && backgroundImage.source ? 'm-teaser-banner' : ('m-teaser-banner m-teaser-banner--' + defaultTheme) ]">

	<cov-image *ngIf="backgroundImage && backgroundImage.source" [image]="backgroundImage"></cov-image>
	
	<div class="m-teaser-banner__body">
		<cov-heading *ngIf="bannerText" [level]="bannerText && bannerText.level" [modifier]="bannerText && bannerText.modifier" [text]="bannerText && bannerText.text" [class]="bannerText && bannerText.class"></cov-heading>
		<p class="m-teaser-banner__description" [innerHTML]="description"></p>
	</div>
	
	<div class="m-teaser-banner__button">
		<cov-button *ngIf="buttonText"
			[buttonlink]="buttonText && buttonText.buttonlink"
			[text]="buttonText && buttonText.text"
			[href]="buttonHref"
			[modifier]="buttonText && buttonText.modifier"
			[class]="buttonText && buttonText.class"
		></cov-button>
	</div>
</div>
